export const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "unisex", label: "Unisex" },
];

export const SkinOptions = [
    { value: "oily", label: "Oily" },
    { value: "dry", label: "Dry" },
    { value: "normal", label: "Normal" },
    { value: "combination", label: "Combination" },
    { value: "sensitive", label: "Sensitive" },
];

export const tagOptions = [
    { value: "aging", label: "Aging" },
    { value: "acne skin", label: "Acne skin" },
    { value: "dehydrated", label: "Dehydrated" },
    { value: "eeactive skin", label: "Reactive skin" },
];

export const tags = [
    { value: "wrinkle", label: "Wrinkle" },
    { value: "retinol", label: "Retinol" },
    { value: "firming", label: "Firming" },
    { value: "anti-aging", label: "Anti-aging" },
    { value: "botox", label: "Botox" },
    { value: "eye-wrinkle", label: "Eye-wrinkle" },
    { value: "hydrating", label: "Hydrating" },
    { value: "eye-care", label: "Eye-care" },
    { value: "brightening", label: "Brightening" },
    { value: "vitamin-c", label: "Vitamin-c" },
    { value: "under-eye", label: "Under-eye" },
    { value: "de-puff", label: "De-puff" },
    { value: "eye-lift", label: "Eye-lift" },
    { value: "hydration", label: "Hydration" },
    { value: "acne", label: "Acne" },
    { value: "blemish-control", label: "Blemish-control" },
    { value: "anti-inflammatory", label: "Anti-inflammatory" },
    { value: "salicylic-acid", label: "Salicylic-acid" },
    { value: "oil-control", label: "Oil-control" },
    { value: "blackhead-removal", label: "Blackhead-removal" },
    { value: "pore-cleansing", label: "Pore-cleansing" },
    { value: "exfoliation", label: "Exfoliation" },
    { value: "whitehead-treatment", label: "Whitehead-treatment" },
    { value: "cleansing", label: "Cleansing" },
    { value: "acne-care", label: "Acne-care" },
    { value: "mattifying", label: "Mattifying" },
    { value: "niacinamide", label: "Niacinamide" },
    { value: "pore-minimizing", label: "Pore-minimizing" },
    { value: "clay-mask", label: "Clay-mask" },
    { value: "chemical-exfoliant", label: "Chemical-exfoliant" },
    { value: "pore-care", label: "Pore-care" },
    { value: "exfoliating", label: "Exfoliating" },
    { value: "resurfacing", label: "Resurfacing" },
    { value: "smoothing", label: "Smoothing" },
    { value: "soothing", label: "Soothing" },
    { value: "calming", label: "Calming" },
    { value: "gentle", label: "Gentle" },
    { value: "fragrance-free", label: "Fragrance-free" },
    { value: "hypoallergenic", label: "Hypoallergenic" },
    { value: "barrier-repair", label: "Barrier-repair" },
    { value: "ceramide", label: "Ceramide" },
    { value: "spot-correction", label: "Spot-correction" },
    { value: "pigmentation", label: "Pigmentation" },
    { value: "azelaic-acid", label: "Azelaic-acid" },
    { value: "moisturizing", label: "Moisturizing" },
    { value: "hyaluronic-acid", label: "Hyaluronic-acid" },
    { value: "water-based", label: "Water-based" },
    { value: "electrolyte", label: "Electrolyte" },
    { value: "moisturizer", label: "Moisturizer" },
    { value: "gentle-cleanser", label: "Gentle-cleanser" },
    { value: "glow", label: "Glow" },
    { value: "tone-correcting", label: "Tone-correcting" },
    { value: "revitalizing", label: "Revitalizing" },
    { value: "energizing", label: "Energizing" },
    { value: "anti-fatigue", label: "Anti-fatigue" },
    { value: "dermatology", label: "Dermatology" },
    { value: "monitoring", label: "Monitoring" },
    { value: "scar-repair", label: "Scar-repair" },
    { value: "healing", label: "Healing" },
    { value: "regeneration", label: "Regeneration" },
    { value: "spot-treatment", label: "Spot-treatment" },
    { value: "alpha-arbutin", label: "Alpha-arbutin" }
];


export const skinConditionDescriptions = ["FOREHEAD WRINKLE", "GLABELLA WRINKLE", "CROWS FEET", "WRINKLES", "NASOLABIAL FOLD", "DARK CIRCLE", "EYE POUCH", "LEFT EYELIDS", "PIMPLES", "ACNE", "BLACKHEADS", "WHITEHEADS", "OILINESS", "LARGE PORES", "CLOGGED PORES", "TEXTURE", "REDNESS", "SENSITIVITY", "IRRITATION", "SKIN SPOT", "HYPERPIGMENTATION", "MELASMA", "DRY SKIN", "DEHYDRATION", "FLAKINESS", "DULLNESS", "UNEVEN SKIN TONE", "TIRED SKIN", "MOLE", "SCARS", "DARK SPOTS"];



export const sidebar = [
    {
        name: "Dashboard",
        subModules: ["Overview", "Beauty", "E-commerce", "Wellness", "Skin-Analysis"]
    },
    // {
    //     name: "Staff",
    //     subModules: []
    // },
    {
        name: "Users",
        subModules: []
    },
    {
        name: "Beauty App",
        subModules: ["Categories", "Sub-Categories", "Sub Cat-services", "Services", "Packages", "Add-ons", "Professional Charges", "Bookings", "Beautician"]
        // subModules: ["Categories", "Sub-Categories", "Sub Cat-services", "Services", "Service Packages", "Packages", "Bookings", "Beautician", "Applications"]
    },
    {
        name: "E-Commerce",
        subModules: ["Shop Categories", "Sub Categories", "Brands", "Colors", "Size", "Products", "Orders",]
    },
    {
        name: "Skin-ai",
        subModules: ["Scans"]
    },
    {
        name: "Wellness",
        subModules: ["Concerns", "Clinics", "Doctors", "Appointments"]
    },
    {
        name: "Settings",
        subModules: ["Locations", "Timeslots", "Offers"]
    },

    {
        name: "CMS",
        subModules: ["Home", "Testimonials", "Blogs", "Media Coverage"]
    },
    {
        name: "Notifications",
        subModules: []
    }
];

export const modules = [{
    access: true,
    expand: true,
    name: "Dashboard",
    subModules: [
        {
            name: "Overview",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]

        },
        {
            name: "Beauty",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]

        },
        {
            name: "E-commerce",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]

        },
        {
            name: "Wellness",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]

        },
        {
            name: "Skin-Analysis",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]

        },

    ]
},
{
    access: true,
    expand: false,
    name: "Staff",
    subModules: [
    ]
},
{
    access: true,
    expand: false,
    name: "Users",
    subModules: [
    ]
},

{
    access: true,
    expand: true,
    name: "Beauty App",
    subModules: [
        {
            name: "Categories",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Sub-Categories",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Sub Cat-Services",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Services",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Packages",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Service Packages",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Add-ons",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Professional Charges",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Bookings",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Beautician",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Applications",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
    ]
},
{
    access: true,
    expand: true,
    name: "E-Commerce",
    subModules: [
        {
            name: "Shop Categories",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Sub Categories",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Brands",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Colors",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Size",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Products",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Orders",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },

    ]
},

{
    access: true,
    expand: true,
    name: "Skin-ai",
    subModules: [
        {
            name: "Scans",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]

        },

    ]
},

{
    access: true,
    expand: true,
    name: "Wellness",
    subModules: [
        {
            name: "Concerns",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]

        },
        {
            name: "Clinics",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]

        },
        {
            name: "Doctors",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]

        },

        {
            name: "Appointments",
            access: false,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },


    ]
},
{
    access: true,
    expand: true,
    name: "Settings",
    subModules: [
        {
            name: "Locations",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Timeslots",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Offers",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
    ]
},

{
    access: true,
    expand: true,
    name: "CMS",
    subModules: [
        {
            name: "Home",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Testimonials",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Blogs",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Media Coverage",
            access: true,
            actions: [{ "name": "view", "access": true },
            { "name": "edit", "access": true },
            { "name": "delete", "access": true },
            { "name": "add", "access": true }
            ]
        },
        {
            name: "Notifications",
            access: true,
            expand: false,
            subModules: []
        }
    ]
},

];



// {
//     "user": "64db78f8d7d8f8a9fcf0c9b7",
//         "allowedCities": ["Mumbai", "Delhi"],
//             "modules": [
//                 {
//                     "name": "beauty",
//                     "access": true,
//                     "subModules": [
//                         {
//                             "name": "dashboard",
//                             "access": true,
//                             "actions": [
//                                 { "name": "view", "access": true },
//                                 { "name": "edit", "access": true },
//                                 { "name": "delete", "access": false }
//                             ]
//                         },
//                         {
//                             "name": "orders",
//                             "access": true,
//                             "actions": [
//                                 { "name": "view", "access": true },
//                                 { "name": "add", "access": true }
//                             ]
//                         }
//                     ]
//                 }
//             ]
// }
